// extracted by mini-css-extract-plugin
export default {"main_upper":"Main_main_upper__CNze4"};